import { PagenatedResponse, SearchPagenateQuery } from '@models/common';
import { NaverCommerceProduct } from '@models/sales-channels';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { createSafeStorage, createSizePartialize } from '@utils/localStorage';

const PAGE_SIZE = 20;

interface NaverCommerceProductsContainer {
  contents: NaverCommerceProduct[];
  page: number;
  size: number;
  total: number;
  hasNext: boolean;
}

export interface NaverCommerceProductsQuery extends SearchPagenateQuery {
  dateType?: string;
  refundStatus?: string;
  keywordType?: string;
  status?: string;
}

interface NaverCommerceProductsStoreProps {
  searchResultContainer: NaverCommerceProductsContainer;
  searchQuery: NaverCommerceProductsQuery;
  searchKeyword?: string;
  setStartDate: (date: string | null) => void;
  setEndDate: (date: string | null) => void;
  setSearchKeyword: (keyword: string) => void;
  updateSearchQuery: (query: { [key: string]: any }) => void;
  resetSearchQuery: () => void;
  setNaverCommerceProductsContainer: (result: PagenatedResponse<NaverCommerceProduct>) => void;
}

export const useNaverCommerceProductsStore = create(
  persist<NaverCommerceProductsStoreProps>(
    (set) => ({
      searchResultContainer: {
        contents: [] as NaverCommerceProduct[],
        total: 0,
        page: 0,
        size: 0,
        hasNext: false,
      },
      searchQuery: {
        page: 0,
        size: PAGE_SIZE,
        startDate: undefined,
        endDate: undefined,
      },
      searchKeyword: undefined,
      setStartDate: (date: string | null) => {
        set((state) => {
          return { ...state, searchQuery: { ...state.searchQuery, startDate: date } };
        });
      },
      setEndDate: (date: string | null) => {
        set((state) => {
          return { ...state, searchQuery: { ...state.searchQuery, endDate: date } };
        });
      },
      setNaverCommerceProductsContainer: (result) => {
        set((state) => {
          // 메모리 효율성을 위해 실제 데이터만 저장
          const newValue = {
            ...state.searchResultContainer,
            ...result,
            contents: result?.contents || [],
          };
          return { ...state, searchResultContainer: newValue };
        });
      },
      setSearchKeyword: (keyword: string) => {
        set((state) => {
          return {
            ...state,
            searchKeyword: keyword,
            searchResultContainer: { ...state.searchResultContainer, size: 0 },
          };
        });
      },
      updateSearchQuery: (query: { [key: string]: any }) => {
        set((state) => {
          return {
            ...state,
            searchQuery: { ...state.searchQuery, ...query },
            searchResultContainer: { ...state.searchResultContainer, size: 0 },
          };
        });
      },
      resetSearchQuery: () => {
        set({
          searchQuery: {
            page: 0,
            size: PAGE_SIZE,
            startDate: undefined,
            endDate: undefined,
          },
        });
      },
    }),
    {
      name: 'igogo-naver-products',
      storage: createSafeStorage(),
      partialize: createSizePartialize<NaverCommerceProductsStoreProps>(100),
    },
  ),
);
